import {NgModule} from '@angular/core';
import {ApparatusListComponent} from './apparatus-list/apparatus-list.component';
import {ApparatusViewComponent} from './apparatus-view/apparatus-view.component';
import {ApparatusCardComponent} from './apparatus-card-form/apparatus-card.component';
import {ApparatusFormFieldsModule} from '@subforms/apparatus-form-fields/apparatus-form-fields.module';
import {ApparatusCardResolverService} from './services/apparatus-card-resolver.service';
import {SharedModule} from '@helpers/modules/shared.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ApparatusCardCommonModule} from '@subforms/apparatus-card-common/apparatus-card-common.module';
import {CalibrationDateComponent} from './components/calibration-date.component';
import {ApparatusCardCalibrationsModule} from '@subforms/apparatus-card-calibrations/apparatus-card-calibrations.module';
import {EquipmentViewModule} from '@modules/equipment-view/equipment-view.module';
import {StatusChangeFormModule} from '@modules/status-change-form/status-change-form.module';
import {EquipmentSelectModule} from '@components/equipment-select/equipment-select.module';
import {PipesModule} from '@pipes/pipes.module';
import {EquipmentCardModule} from '@modules/equipment-card/equipment-card.module';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {ApparatusCardRepairsModule} from '@subforms/apparatus-card-repairs/apparatus-card-repairs.module';
import {EquipmentPagesResolverService} from './services/equipment-pages/equipment-pages-resolver.service';
import {EquipmentPagesService} from './services/equipment-pages/equipment-pages.service';
import {EquipmentPagesResetOnDeactivateService} from './services/equipment-pages/equipment-pages-reset-on-deactivate.service';
import { DocumentsGenerationButtonComponent } from './components/documents-generation-button/documents-generation-button.component';
import { DocumentsGenerationMenuComponent } from './components/documents-generation-menu/documents-generation-menu.component';
import { CalibrationRequestModalComponent } from './components/calibration-request-modal/calibration-request-modal.component';
import {EquipmentControlService} from './services/equipment-control.service';
import {EquipmentListItemComponent} from './components/equipment-list-item/equipment-list-item.component';
import {IconsModule} from '@lab365/icons';
import {Lab365CommonModule} from '@lab365/common';
import {CalibrationScheduleModule} from './calibration-schedule/calibration-schedule.module';

@NgModule({
    providers: [
        ApparatusCardResolverService,

        EquipmentPagesResolverService,
        EquipmentPagesService,
        EquipmentPagesResetOnDeactivateService,

        EquipmentControlService,
    ],
    declarations: [
        ApparatusListComponent,
        ApparatusViewComponent,
        ApparatusCardComponent,
        CalibrationDateComponent,
        DocumentsGenerationButtonComponent,
        DocumentsGenerationMenuComponent,
        CalibrationRequestModalComponent,
        EquipmentListItemComponent,
    ],
    imports: [
        SharedModule,
        FormFieldModule,
        ApparatusFormFieldsModule,
        ApparatusCardCommonModule,
        ApparatusCardCalibrationsModule,
        ApparatusCardRepairsModule,
        DirectivesModule,
        EquipmentSelectModule,
        EquipmentViewModule,
        PipesModule,
        PagingControlModule,
        EquipmentCardModule,
        StatusChangeFormModule,
        IconsModule,
        Lab365CommonModule,
        CalibrationScheduleModule,
    ],
    exports: []
})
export class ApparatusModule {}
